import React from 'react';
import { Space } from 'antd';
import { BackendLogsPanel } from './BackendLogsPanel';

export const ErrorLogs: React.FC = () => (
  <Space direction="vertical" size="middle" className="w-full">
    <BackendLogsPanel title="Backend Error Logs" kind="errors" service="golden-hounds-backend" autoRefresh />
    <BackendLogsPanel title="Game Server Error Logs" kind="errors" service="golden-hounds-game-server" autoRefresh />
  </Space>
);
